import { unitTypes, distanceRouteURL } from '../config';
import axios from 'axios';
import { googleMapLoader } from './googleMapLoader';
import { getConfigSettings } from './getConfigSettings';
export async function getDistanceAndDuration({ distanceType, pickUpLocation, dropLocation }) {
    try {
        await googleMapLoader()
        let result = { totalDistance: 0, totalDuration: 0, bookingLocations: [] }, origin = {}, destination = {}, units = unitTypes[distanceType];
        let locationDistance = 0, locationDuration = 0;
        if (!pickUpLocation || !dropLocation || !units || !units?.value || !google || !google.maps) return result;
        origin.location = { latLng: { latitude: pickUpLocation?.location?.lat, longitude: pickUpLocation?.location?.lng } };
        destination.location = { latLng: { latitude: dropLocation?.location?.lat, longitude: dropLocation?.location?.lng } };
        // Add booking locations for pick-up and drop
        result['bookingLocations'].push({
            id: pickUpLocation?.id || null,
            location: pickUpLocation?.location?.location,
            locationLat: pickUpLocation?.location?.lat,
            locationLng: pickUpLocation?.location?.lng,
            locationStatus: pickUpLocation?.location?.locationStatus || 'pending',
            locationDistanceType: distanceType,
            locationType: 'pickup',
            locationDistance,
            locationDuration
        });
        result['bookingLocations'].push({
            id: dropLocation?.id || null,
            location: dropLocation?.location?.location,
            locationLat: dropLocation?.location?.lat,
            locationLng: dropLocation?.location?.lng,
            locationStatus: dropLocation?.location?.locationStatus || 'pending',
            locationDistanceType: distanceType,
            locationType: 'drop',
            locationDistance,
            locationDuration
        });

        await google.maps.importLibrary('core');
        const requestData = {
            origin,
            destination,
            travelMode: 'DRIVE',
            units: google.maps.UnitSystem[units?.value?.toUpperCase()]
        }
        const configData = await getConfigSettings({ name: ['googleMapBrowserApiKey'] })
        const response = await axios.post(distanceRouteURL, requestData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Goog-Api-Key': configData?.googleMapBrowserApiKey,
                'X-Goog-FieldMask': 'routes'
            },
        });
        if (response?.data?.routes && response?.data?.routes?.length > 0) {
            locationDuration = Number(response?.data?.routes[0].duration.match(/\d+/)[0]) > 0 ? Number(response?.data?.routes[0].duration.match(/\d+/)[0]) / 60 : 0;
            locationDistance = response?.data?.routes[0]?.distanceMeters > 0 ? response?.data?.routes[0]?.distanceMeters / units?.convertFromMeter : 0;
        }
        result['bookingLocations'][0] = { ...result['bookingLocations'][0], locationDistance, locationDuration };
        result['bookingLocations'][1] = { ...result['bookingLocations'][1], locationDistance, locationDuration };
        result['totalDuration'] = locationDuration;
        result['totalDistance'] = locationDistance;
        result['directions'] = response;
        return result;
    } catch (error) {
        return null;
    }
}